import { parseAsString, useQueryState } from 'nuqs'
import { useDebounce } from 'use-debounce'

export const useSearchBiblioteca = () => {
  const [searchText, setSearchText] = useQueryState(
    'search',
    parseAsString.withDefault('')
  )

  const [searchDebounce] = useDebounce(searchText, 150)

  const isSearching = searchDebounce !== ''

  return {
    searchText,
    setSearchText,
    searchDebounce,
    isSearching
  }
}
